import Breadcrumb from '../../core/components/UI/Breadcrumb'
import { useCountryContext } from '../../core/context/country/CountryProvider'
import FormCreateOpportunity from '../components/opportunity-create-page/FormCreateOpportunity'

export default function OpportunityCreatePage() {
  const { countryState } = useCountryContext()
  return (
    <>
      <Breadcrumb
        links={[
          {
            id: 1,
            label: 'المناطق',
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 2,
            label: countryState.country?.name_ar,
            isActive: false,
            to: `/countries/opportunities`,
          },
          {
            id: 3,
            label: 'الفرص الاستثمارية',
            isActive: false,
            to: '/countries/opportunities',
          },
          {
            id: 4,
            label: 'إضافة',
            isActive: true,
          },
        ]}
      />
       <div className="border-2 border-muted-500 bg-white p-2">
        <FormCreateOpportunity />
       </div>
    </>
  )
}
